// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","container":"container--1EJ2B","containerBody":"containerBody--2KXJd","searchContent":"searchContent--2W3cl","actionButtons":"actionButtons--1aCc3"};